export default {"src":"/_next/static/media/menu_bold.3fe25384.svg","height":24,"width":24};